import api from 'app/api';
import store from 'app/store';
import { createImageId, dataURLtoFile, updateImageId } from '../../utils/commonUtils';
import Compressor from 'compressorjs';
import { DEFAULT_END_DATE, DEFAULT_START_DATE } from './constants';
import { addHours } from 'date-fns';
import { OTP_LENGTH } from '../../constants/common';
// const eventCreateState = store.getState().eventCreate;

const createEvent = async (payload, callback) => {
  const successCallback = ({ data }) => {
    console.log(data);
    store.dispatch({ type: 'EVENT_CREATE:SAVED_EVENT_DATA:SET', data });

    if (callback) callback(data);
  };

  await api.post(
    '/events/create',
    payload,
    {
      id: 'save-event',
      success: {
        callback: successCallback,
      },
    },
  );
};

const updateEvent = async (id, payload, isPublish, callback) => {
  const successCallback = ({ data }) => {
    console.log(data);
    store.dispatch({ type: 'EVENT_CREATE:SAVED_EVENT_DATA:SET', data });

    if (callback) callback(data);
  };

  await api.put(
    `/events/primary/${id}`,
    payload,
    {
      id: 'save-event',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      ...(isPublish && ({
        params: {
          publish: true,
        }
      })),
    },
  );
};

const getEvent = async (id, callback) => {
  const successCallback = ({ data }) => {
    console.log(data);
    let updatedData = data?.payload;
    if (data?.payload?.start_date && (new Date(data?.payload?.start_date) < Date.now() || addHours(new Date(data?.payload?.start_date), 2) <= Date.now())) {
      updatedData = { ...updatedData, start_date: DEFAULT_START_DATE, end_date: DEFAULT_END_DATE };
    }
    store.dispatch({ type: 'EVENT_CREATE:EVENT_DATA:SET', data: updatedData });
    store.dispatch({ type: 'EVENT_CREATE:SAVED_EVENT_DATA:SET', data });

    if (callback) callback(data);
  };

  await api.get(
    `/events/${id}`,
    {
      id: 'save-event',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

const sendOtp = async (phoneNumber, id, callback) => {
  await api.post(
    '/user/otp/send',
    {
      phoneNumber: `91${phoneNumber}`,
      orderId: id,
      otpLength: OTP_LENGTH,
      channel:'SMS',
      expiry: 90,
    },
    {
      id: 'send-otp',
      failure: {
        callback,
      },
      success: {
        callback,
      },
    },
  );
};

const resendOtp = async (id, mobileNumber) => {
  await api.post(
    '/user/otp/resend',
    {
      orderId: id,
      phoneNumber: `91${mobileNumber}`,
    },
    {
      id: 'send-otp',
      failure: {
        showNotifier: true,
      },
    },
  );
};

const verifyOtp = async (phoneNumber, otp, id, cb) => {
  const successCallback = (data) => {
    if (cb) cb(data);
  };

  await api.post(
    '/user/otp/verify',
    {
      orderId: id,
      otp,
      phoneNumber: `91${phoneNumber}`,
    },
    {
      id: 'send-otp',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

const createBusinessConfig = async (payload, cb) => {
  const successCallback = ({ data }) => {
    console.log(data);
    store.dispatch({ type: 'EVENT_CREATE:BUSINESS_CONFIG:SET', data: data?.organiser });
    if (data?.user) {
      store.dispatch({ type: 'APP:USER_DATA:SET', data: { ...data.user } });
    } else store.dispatch({ type: 'APP:USER_DATA:SET', data: { ...data, business_config_id: data?.id } });

    if (data?.tokens) {
      store.dispatch({ type: 'APP:SET_JWT_TOKEN', data: data.tokens, refresh: true });
    }

    if (cb) cb(data);
  };

  await api.post(
    `/organisers/0/approve`,
    payload,
    {
      id: 'save-business-config',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

const updateBusinessConfig = async (id, payload, cb) => {
  const successCallback = ({ data }) => {
    console.log(data);
    store.dispatch({ type: 'EVENT_CREATE:BUSINESS_CONFIG:SET', data });

    if (cb) cb(data);
  };

  return await api.put(
    `/organisers/configs`,
    payload,
    {
      id: 'save-business-config',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

const getBusinessConfig = async (id) => {
  const successCallback = ({ data }) => {
    console.log(data);
    store.dispatch({ type: 'EVENT_CREATE:BUSINESS_CONFIG:SET', data });
  };

  await api.get(
    `/organisers/${id}/approve`,
    {
      id: 'save-business-config',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

const uploadImage = async (params) => {
  const {
    image,
    id,
    tag,
    fileName,
    loaderId,
  } = params;
  let imageFile = image;

  if (typeof imageFile === 'string') imageFile = dataURLtoFile(image);

  try {
    let finalImage = imageFile;

    // Check if the file is a PDF
    const isPDF = imageFile.type === 'application/pdf';

    if (!isPDF) {
      // Process only if it's an image
      const compressedImage = await compressImage(imageFile);
      finalImage = await applyBrightness(compressedImage, 1.0);
    }

    let resp = null;
    if (id) {
      resp = await updateImageId(id, finalImage, tag, loaderId);
    } else {
      resp = await createImageId(finalImage, tag, fileName, loaderId);
    }
    return resp;

  } catch (error) {
    console.error("Image/PDF upload failed:", error);
    throw error;
  }
};

const compressImage = (file) => {
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      quality: 1,
      mimeType: "image/webp",
      maxWidth: 1600,
      maxHeight: 1600,
      success(result) {
        resolve(result);
      },
      error(err) {
        console.error("Compression failed:", err);
        reject(err);
      },
    });
  });
};

const applyBrightness = (file, brightnessFactor) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function (event) {
      const img = new Image();
      img.src = event.target.result;
      img.onload = function () {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = img.width;
        canvas.height = img.height;

        ctx.filter = `brightness(${brightnessFactor}) contrast(1.1)`;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        canvas.toBlob((blob) => {
          if (blob) {
            const finalFile = new File([blob], "compressed.webp", { type: "image/webp" });
            resolve(finalFile);
          } else {
            reject(new Error("Failed to convert image."));
          }
        }, "image/webp", 0.9);
      };
    };
  });
};

const getImage = async (id) => {
  const response = await api.get(
    `/image/${id}`,
    {
      id: 'get-image-by-id',
    }
  );

  return response?.data?.data?.url;
};

const autoCompleteSearch = async (searchText, location = '13.067439,80.237617', callback) => {
  await api.get(
    `/maps/autocomplete?input=${searchText}&location=${encodeURIComponent(location)}&strictbounds=true`,
    {
      id: 'autocomplete-search',
      success: {
        callback: callback,
      },
    },
  );
};

const geoCodeLocation = async (address, callback) => {
  return fetch(
    `https://api.olamaps.io/places/v1/geocode?address=${encodeURIComponent(address)}&api_key=ntZp3UYw8sQjqjF1SnSvffI2QBeZaA0gProAtSD0`
  );
};

const getPastEventList = async (businessConfigId, callback) => {
  const successCallback = ({ data }) => {
    let eventsList = data?.past?.data || [];

    if (callback) callback(eventsList);
  };

  await api.post(
    `/events/${businessConfigId}`,
    {
      live: false,
      past: true,
      draft: false,
      upcoming: false,
    },
    {
      id: 'search-past-event',
      success: {
        callback: successCallback,
      },
      params: {
        page_no: 0,
        page_size: 1,
      },
    },
  );
};

const getPriceBreakup = async (price, action = 'EVENT_CREATE') => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: `${action}:PRICE_BREAKUP:SET`, price, data });
  };

  await api.get(
    `/events/price-breakup`,
    {
      id: 'get-org-price-breakup',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      params: {
        unit_price: price,
        quantity: 1,
      },
    },
  );
};

export {
  createEvent,
  updateEvent,
  getEvent,
  sendOtp,
  resendOtp,
  verifyOtp,
  createBusinessConfig,
  updateBusinessConfig,
  getBusinessConfig,
  uploadImage,
  autoCompleteSearch,
  geoCodeLocation,
  getPastEventList,
  getImage,
  getPriceBreakup,
};
